import { render } from "./ViewOrderWarranties.vue?vue&type=template&id=b2a57a00&scoped=true"
import script from "./ViewOrderWarranties.vue?vue&type=script&lang=js"
export * from "./ViewOrderWarranties.vue?vue&type=script&lang=js"

import "./ViewOrderWarranties.vue?vue&type=style&index=0&id=b2a57a00&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2a57a00"]])

export default __exports__